/**
 * 
 * App.js
 * 
 */
import React, { Fragment, Component } from "react";

// components
import SmileNav from './components/nav/SmileNav';
import BodyWrapper from './components/body/BodyWrapper';



export default class App extends Component {

  static displayName = App.name;

  componentDidMount() {
    document.title = "Smile.";
  }


  render() {
    // let location = useLocation();
    
    return (
    
      <Fragment>
  
        <SmileNav />
        
        <BodyWrapper />


      </Fragment>
      
      
    );

  }

}


